import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';

class ChipView extends React.PureComponent {
    render() {
        const chipView = (
            <div className={styles.content_list}>
                <Chip id="40009" type="static" title="要闻区地方站辽宁" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40010" type="static" title="要闻区地方站山东" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40011" type="static" title="要闻区地方站河北" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40012" type="static" title="要闻区地方站湖北" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40013" type="static" title="要闻区地方站江苏" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40014" type="static" title="要闻区地方站湖南" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40015" type="static" title="要闻区地方站陕西" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40016" type="static" title="要闻区地方站浙江" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40017" type="static" title="要闻区地方站江西" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40018" type="static" title="要闻区地方站海南" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40019" type="static" title="要闻区地方站安徽" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40020" type="static" title="要闻区地方站广东" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40021" type="static" title="要闻区地方站重庆" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40022" type="static" title="要闻区地方站黑龙江" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40023" type="static" title="要闻区地方站四川" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40024" type="static" title="要闻区地方站吉林" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40025" type="static" title="要闻区地方站甘肃" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40026" type="static" title="要闻区地方站河南" groupName="要闻区地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40028" type="static" title="要闻区地方站最后一条辽宁" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40029" type="static" title="要闻区地方站最后一条山东" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40033" type="static" title="要闻区地方站最后一条河北" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40031" type="static" title="要闻区地方站最后一条湖北" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40032" type="static" title="要闻区地方站最后一条江苏" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40030" type="static" title="要闻区地方站最后一条湖南" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40034" type="static" title="要闻区地方站最后一条陕西" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40027" type="static" title="要闻区地方站最后一条浙江" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40035" type="static" title="要闻区地方站最后一条江西" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40036" type="static" title="要闻区地方站最后一条海南" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40037" type="static" title="要闻区地方站最后一条安徽" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40038" type="static" title="要闻区地方站最后一条广东" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40039" type="static" title="要闻区地方站最后一条重庆" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40040" type="static" title="要闻区地方站最后一条黑龙江" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40041" type="static" title="要闻区地方站最后一条四川" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40042" type="static" title="要闻区地方站最后一条吉林" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40043" type="static" title="要闻区地方站最后一条甘肃" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40044" type="static" title="要闻区地方站最后一条河南" groupName="要闻区地方站最后一条">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40051" type="static" title="房产头条广州" groupName="房产头条地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40052" type="static" title="房产列表一地方站广州" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40053" type="static" title="房产列表一地方站青岛" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40054" type="static" title="房产列表一地方站大连" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40055" type="static" title="房产列表一地方站南京" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40056" type="static" title="房产列表一地方站杭州" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40057" type="static" title="房产列表一地方站上海" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40058" type="static" title="房产列表一地方站西安" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40059" type="static" title="房产列表一地方站长沙" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40060" type="static" title="房产列表一地方站济南" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40061" type="static" title="房产列表一地方站成都" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40062" type="static" title="房产列表一地方站重庆" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40063" type="static" title="房产列表一地方站深圳" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40064" type="static" title="房产列表一地方站天津" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40065" type="static" title="房产列表一地方站烟台" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40066" type="static" title="房产列表一地方站武汉" groupName="房产列表一地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40067" type="static" title="房产列表二地方站广州" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40068" type="static" title="房产列表二地方站青岛" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40069" type="static" title="房产列表二地方站大连" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40070" type="static" title="房产列表二地方站南京" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40071" type="static" title="房产列表二地方站杭州" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40072" type="static" title="房产列表二地方站上海" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40073" type="static" title="房产列表二地方站西安" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40074" type="static" title="房产列表二地方站长沙" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40075" type="static" title="房产列表二地方站济南" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40076" type="static" title="房产列表二地方站成都" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40077" type="static" title="房产列表二地方站重庆" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40078" type="static" title="房产列表二地方站深圳" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40079" type="static" title="房产列表二地方站天津" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40080" type="static" title="房产列表二地方站烟台" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40081" type="static" title="房产列表二地方站武汉" groupName="房产列表二地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40082" type="static" title="房产左侧地方站广州" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40083" type="static" title="房产左侧地方站青岛" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40084" type="static" title="房产左侧地方站大连" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40085" type="static" title="房产左侧地方站南京" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40086" type="static" title="房产左侧地方站杭州" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40087" type="static" title="房产左侧地方站上海" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40088" type="static" title="房产左侧地方站西安" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40089" type="static" title="房产左侧地方站长沙" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40090" type="static" title="房产左侧地方站济南" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40091" type="static" title="房产左侧地方站成都" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40092" type="static" title="房产左侧地方站重庆" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40093" type="static" title="房产左侧地方站深圳" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40094" type="static" title="房产左侧地方站天津" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40095" type="static" title="房产左侧地方站烟台" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="40096" type="static" title="房产左侧地方站武汉" groupName="房产左侧地方站">
                    <div className={styles.chip_item} />
                </Chip>
            </div>
        );

        return ReactDOM.createPortal(chipView, document.body);
    }
}

export default errorBoundary(ChipView);
